import { PaginatedReviewResponse } from '@/types/api'
import { ReviewItem, ReviewSheetParams } from '@/types/collection'
import { httpClient } from './http-client'

export const __cReviewService = {
  getReviews: async (productId: string, params?: Record<string, string>) => {
    const response = await httpClient.V1.get<
      PaginatedReviewResponse<ReviewItem[]>
    >(
      `/reviews/filter?current_product_id=${productId}${
        params ? `&${new URLSearchParams(params).toString()}` : ''
      }`
    )

    return response
  },
  getReviewBySheetId: async <T>(params: ReviewSheetParams): Promise<T> => {
    const { data } = await httpClient.V1.get<{ data: T }>(
      `/tools/get-data-from-sheet`,
      {
        params,
      }
    )
    return data
  },
}
